<template>
  <div class="icon-hover" @mouseleave="showInfo = false">
    <div :class="['fill-text', { active: showInfo }]">
      <img
        src="@/assets/images/icons/info@2x.png"
        alt=""
        srcset=""
        class="info-button"
        @mouseover="showInfo = true"
      />
      <div class="fill-text info-text text-white p-2" v-show="showInfo">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showInfo: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.info-button {
  background-color: white;
  border-radius: 50%;
  height: 1.5em;
  position: absolute;
}
.fill-text {
  &.active {
    
    background-color: #ed426f;
    position: absolute;

    z-index: 5;
  }
  border-radius: 1em;
  margin-right: 1em;
}
.info-text {
margin-top:1em;
}
</style>